import { toast } from "react-toastify";

const toaster = {
  error: (message: string) => {
    toast.error(message, { position: "top-right" });
  },
  success: (message: string) => {
    toast.success(message, { position: "top-right" });
  },
};

export default toaster;
